import React from 'react';
import { SubscriptionLayout } from '../components/SubscriptionLayout';
import { BillingInfo } from '../components/BillingInfo';

export const BillingInfoPage = () => {
  return (
    <SubscriptionLayout activeTab="billing-info">
      <BillingInfo />
    </SubscriptionLayout>
  );
};
